import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const formatNumber = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatDate = (value) => {
  if (!value) {
    return "-";
  }

  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) {
    return "-";
  }

  return dt.toLocaleDateString("en-GB").replace(/\//g, ".");
};

export default function StandardProduceViewModal({
  show,
  onHide,
  data,
  loading = false,
  fiscalYear,
}) {
  const components = data?.components || [];
  const produced = data?.produced || {};
  const totalComponents = components.length;
  const totalComponentQty = components.reduce((sum, item) => sum + Number(item?.Qty || 0), 0);

  return (
    <Modal show={show} onHide={onHide} centered size="xl" className="SPP__view-modal">
      <Modal.Header closeButton className="SPP__view-modal-header">
        <Modal.Title className="SPP__view-modal-title">Pamja e Fletës së Prodhimit</Modal.Title>
      </Modal.Header>

      <Modal.Body className="SPP__view-modal-body">
        {loading ? (
          <div className="SPP__view-loading">Duke ngarkuar të dhënat...</div>
        ) : (
          <>
            <section className="SPP__view-hero">
              <div className="SPP__view-hero-main">
                <div className="SPP__view-hero-overline">Produkti i prodhuar</div>
                <h3 className="SPP__view-hero-title">{produced?.articleName || "-"}</h3>
                <div className="SPP__view-hero-meta">
                  <span className="SPP__view-chip">Nr. Fletës: PRD-{fiscalYear}-{data?.invoiceNr || "-"}</span>
                  <span className="SPP__view-chip">Data: {formatDate(data?.date)}</span>
                  <span className="SPP__view-chip">Barkodi: {produced?.barcode || "-"}</span>
                  <span className="SPP__view-chip">Njësia: {produced?.unitName || "-"}</span>
                </div>
              </div>

              <div className="SPP__view-hero-stats">
                <div className="SPP__view-stat-card">
                  <span className="SPP__view-stat-label">Sasia e prodhuar</span>
                  <strong className="SPP__view-stat-value">{formatNumber(produced?.qty)}</strong>
                </div>
                <div className="SPP__view-stat-card">
                  <span className="SPP__view-stat-label">Vlera totale</span>
                  <strong className="SPP__view-stat-value">{formatNumber(data?.total)}</strong>
                </div>
              </div>
            </section>

            <div className="SPP__view-note">
              <strong>Përshkrimi:</strong> {data?.comment || "-"}
            </div>

            <div className="SPP__view-components-wrap">
              <div className="SPP__view-components-head">
                <div className="SPP__view-components-title">Recepturat e konsumuara</div>
                <div className="SPP__view-components-count">
                  Komponentë: {totalComponents} | Totali i sasive: {formatNumber(totalComponentQty)}
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-sm align-middle SPP__view-components-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Barkodi</th>
                      <th>Emërtimi</th>
                      <th>Njësia</th>
                      <th className="text-end">Sasia për njësi</th>
                      <th className="text-end">Sasia totale</th>
                      <th className="text-end">Çmimi mesatar</th>
                      <th className="text-end">Vlera</th>
                    </tr>
                  </thead>
                  <tbody>
                    {components.length === 0 ? (
                      <tr>
                        <td colSpan={8} className="text-center text-muted py-3">
                          Kjo fletë prodhimi nuk ka receptura të regjistruara.
                        </td>
                      </tr>
                    ) : (
                      components.map((item, index) => (
                        <tr key={item?.ArticleComponentsID || `${item?.ArticlesID || "cmp"}-${index}`}>
                          <td>{index + 1}</td>
                          <td>{item?.Barcode || "-"}</td>
                          <td>{item?.ArticleName || "-"}</td>
                          <td>{item?.UnitName || "-"}</td>
                          <td className="text-end">{formatNumber(item?.QtyPerUnit)}</td>
                          <td className="text-end">{formatNumber(item?.Qty)}</td>
                          <td className="text-end">{formatNumber(item?.CmimiMesatar)}</td>
                          <td className="text-end">{formatNumber(item?.TotalAmount)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer className="SPP__view-modal-footer">
        <Button variant="secondary" onClick={onHide} className="SPP__view-close-btn">
          Mbyll
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
